import axios from "axios";
import Config from "@/Config.js";

const RUTAS = Config.host + "Routes";
const PARADAS = Config.host + "RouteStops";

/**
 * Rutas y sus paradas.
 *
 * Los dos primeros metodos son publicos: los usa la vista de Rutas y no exigen
 * sesion, pero solo devuelven rutas ACTIVAS y, dentro de ellas, las paradas
 * visibles. Todo lo demas es de administrador.
 *
 * No hay crear ni eliminar por separado: save hace las dos cosas segun venga o
 * no el id, igual que en mesas y lugares.
 */
export default {
  /** Listado publico: solo rutas activas. No exige sesion. */
  buscarPublicas(text = "", page = 0) {
    return axios.get(`${RUTAS}/public`, { params: { text, page } }).then((r) => r.data);
  },
  /** Una ruta por su slug, con sus paradas visibles. No exige sesion. */
  porSlug(slug) {
    return axios.get(`${RUTAS}/public/${slug}`).then((r) => r.data);
  },
  /**
   * Suma una vista. No exige sesion.
   *
   * Quien la llama ignora el fallo a proposito: que no se pueda contar una
   * visita no es razon para romperle la pagina al visitante.
   */
  sumarVista(idRuta) {
    return axios.post(`${RUTAS}/${idRuta}/view`).then((r) => r.data);
  },

  buscar(text = "", page = 0) {
    return axios.get(RUTAS, { params: { text, page } }).then((r) => r.data);
  },
  getById(idRuta) {
    return axios.get(`${RUTAS}/${idRuta}`).then((r) => r.data);
  },
  guardar(ruta) {
    return axios.post(`${RUTAS}/save`, ruta).then((r) => r.data);
  },
  /** Encender o apagar. PUT y no PATCH: CorsConfig no permite PATCH. */
  activar(idRuta, active) {
    return axios.put(`${RUTAS}/${idRuta}/active`, { active }).then((r) => r.data);
  },
  /** Imagenes propias de la ruta. La primera es la portada. */
  imagenes(idRuta) {
    return axios.get(`${RUTAS}/${idRuta}/images`).then((r) => r.data);
  },
  guardarImagen(idRuta, base64) {
    return axios
      .post(`${RUTAS}/${idRuta}/images/save`, { idEntity: idRuta, path: base64 })
      .then((r) => r.data);
  },
  eliminarImagen(idImagen) {
    return axios.delete(`${RUTAS}/images/delete/${idImagen}`).then((r) => r.data);
  },

  eliminar(idRuta) {
    return axios.delete(`${RUTAS}/delete/${idRuta}`).then((r) => r.data);
  },

  // Paradas
  paradasDeRuta(idRuta) {
    return axios.get(`${PARADAS}/route/${idRuta}`).then((r) => r.data);
  },
  guardarParada(parada) {
    return axios.post(`${PARADAS}/save`, parada).then((r) => r.data);
  },
  eliminarParada(idParada) {
    return axios.delete(`${PARADAS}/delete/${idParada}`).then((r) => r.data);
  },
  /**
   * Reordena la ruta entera de un golpe. Hay que mandar TODOS los ids, en el
   * orden nuevo; el backend rechaza una lista incompleta.
   *
   * Devuelve las paradas como quedaron guardadas, para pintar eso y no lo que
   * el front creia haber mandado.
   */
  reordenarParadas(idRuta, idsEnOrden) {
    return axios.put(`${PARADAS}/route/${idRuta}/order`, idsEnOrden).then((r) => r.data);
  },
};
